@if (submitted && control !==undefined && control.invalid) {
  <span class="fn-msg-err text-break" [ngClass]="position"
  >{{(control.errors.message  || 'Invalid ')| fnTranslate}}</span>
}
